/*
 * Delivery day on the product page: "Отримаєте в суботу або понеділок" and
 * when it leaves ("Відправимо сьогодні, якщо замовите до 16:00").
 *
 * A weekday persuades where "1–2 дні" does not — it answers "will it be here
 * by Saturday?" without arithmetic. Full day names and no date (Alik,
 * 15.10.2026: "сб–пн, 17–19.10" read like a timetable). The rules are
 * deliberately plain:
 *
 *   - "now" is Kyiv time, whatever the visitor's clock says;
 *   - we ship Mon–Fri (Sat when the setting says so) before the cutoff hour,
 *     otherwise on the next shipping day;
 *   - it arrives min…max days after it ships, and a day that lands on Sunday
 *     moves to Monday, so the promise errs late rather than early.
 *
 * Settings arrive as data-* on [data-cp-eta] (snippets/cp-pdp-service.liquid).
 */
(function () {
  var DAYS_ON = ['в неділю', 'в понеділок', 'у вівторок', 'в середу', 'в четвер', 'в пʼятницю', 'в суботу'];
  var DAYS_ACC = ['неділю', 'понеділок', 'вівторок', 'середу', 'четвер', 'пʼятницю', 'суботу'];

  function kyivNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Kyiv', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false,
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    // A calendar date with no time zone attached: all arithmetic below is in days.
    return { date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)), hour: +parts.hour % 24 };
  }

  function addDays(d, n) { return new Date(d.getTime() + n * 86400000); }
  function render(el) {
    var cutoff = parseInt(el.dataset.cutoff, 10) || 16;
    var saturday = el.dataset.saturday === 'true';
    var min = Math.max(0, parseInt(el.dataset.min, 10) || 1);
    var max = Math.max(min, parseInt(el.dataset.max, 10) || min);

    var now = kyivNow();
    var ships = function (d) { var w = d.getUTCDay(); return (w >= 1 && w <= 5) || (saturday && w === 6); };

    var ship = now.date;
    var shipsToday = ships(ship) && now.hour < cutoff;
    if (!shipsToday) {
      do { ship = addDays(ship, 1); } while (!ships(ship));
    }

    var arrive = function (n) {
      var d = addDays(ship, n);
      return d.getUTCDay() === 0 ? addDays(d, 1) : d;
    };
    var from = arrive(min);
    var to = arrive(max);

    var dateEl = el.querySelector('[data-cp-eta-date]');
    var shipEl = el.querySelector('[data-cp-eta-ship]');

    // "в суботу" / "в суботу або понеділок": both days in the accusative, the
    // second without its preposition so the line reads as one phrase.
    var when = from.getTime() === to.getTime()
      ? DAYS_ON[from.getUTCDay()]
      : DAYS_ON[from.getUTCDay()] + ' або ' + DAYS_ACC[to.getUTCDay()];
    if (dateEl) dateEl.textContent = 'Отримаєте ' + when;

    var shipText;
    if (shipsToday) {
      shipText = 'Відправимо сьогодні, якщо замовите до ' + cutoff + ':00';
    } else if (ship.getTime() === addDays(now.date, 1).getTime()) {
      shipText = 'Відправимо завтра';
    } else {
      shipText = 'Відправимо ' + DAYS_ON[ship.getUTCDay()];
    }
    if (shipEl) shipEl.textContent = shipText + ' · Нова Пошта';
  }

  function init() {
    document.querySelectorAll('[data-cp-eta]').forEach(render);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
